import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Section, KV } from "@/components/common/ui-bits";
import { FormDialog } from "@/components/common/FormDialog";
import { ROLE_LABELS } from "@/lib/format";

export default function Profile() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <div>
      <PageHeader title="Mi perfil" />
      <Section title="Cuenta" actions={<Button variant="outline" onClick={() => setOpen(true)} data-testid="change-password-button">Cambiar contraseña</Button>}>
        <KV items={[["Nombre", user.name], ["Correo", user.email], ["Rol", ROLE_LABELS[user.role]]]} />
      </Section>
      <FormDialog open={open} onOpenChange={setOpen} title="Cambiar contraseña" testid="password-form"
        fields={[{ name: "current_password", label: "Contraseña actual", type: "password", required: true }, { name: "new_password", label: "Nueva contraseña", type: "password", required: true, minLength: 8 }]}
        onSubmit={async (v) => { await api.post("/auth/change-password", v); toast.success("Contraseña actualizada"); }} />
    </div>
  );
}
